import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Header from './layout/Header';
import NavBarNew from './layout/Nav';
import Footer from './layout/Footer';
import { useState } from 'react';
import { Route, Routes as Switch, Navigate as Redirect } from 'react-router-dom';
import HomeIndex from './views/home';
import Glossary from './views/glossary';
import VariazioniTerritorio from './views/variazioniTerritorio/index';
import TerritorialUnits from './views/territorialUnits';
import StoriaUA from 'views/storiaUA';
import { NewDownloadPage } from 'components/NewDownloadPage';
import RicercaCodice from 'views/ricercaCodice';
import RicostruzioneCodici from 'views/ricostruzioneCodici';
import { useDispatch, useSelector } from 'react-redux';
import IsMobile from 'components/IsMobile/IsMobile';
import TabSkip from 'services/TabSkip/TabSkip';

const App = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const [defaultSkip, setDefaultSkip] = useState(true);
  const [queryString, setQueryString] = useState('');
  const [resetCounter, setResetCounter] = useState(1);

  return (
    <>
      <IsMobile />
      <TabSkip props={ {defaultSkip, queryString} } /> 
      <Header />
      <NavBarNew resetCounter={resetCounter} setResetCounter={(value) => setResetCounter(value)} />
      <div className="situas-container-div">
        <Switch>

          <Route path="/home/*" element={
            <HomeIndex 
              isMobile={isMobile}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)}
            />}
          />

          <Route path="/territorio/*" element={
            <TerritorialUnits
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)} 
            />} 
          />

          <Route path="/variazioni/*" element={
            <VariazioniTerritorio 
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)} 
            />} 
          />

          <Route path="/ricostruzione-codici/*" element={
            <RicostruzioneCodici 
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)} 
            />} 
          />

          <Route path="/storia_ua/*" element={
            <StoriaUA 
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)}
            />} 
          />

          <Route path="/ricerca-codice/*" element={
            <RicercaCodice
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)}
            />}
          />

          <Route path="/glossario/*" element={
            <Glossary 
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={(value) => setDefaultSkip(value)}
              queryString={(value) => setQueryString(value)}
            />} exact 
          />

          {/* FASE 3 - PAGINA DOWNLOAD OSCURATA
          <Route path="/download/*" element={
            <NewDownloadPage
              isMobile={isMobile}
              resetCounter={resetCounter}
              defaultSkip={() => setDefaultSkip(false)}
              queryString={(value) => setQueryString(value)}
            />}
          />
          */}
          
          <Route path="*" exact={true} element={<Redirect to="/home" />} />
          
        </Switch>
      </div>
      <footer id="footer">
        <Footer isMobile={isMobile} />
      </footer>
    </>
  );
};

export default App;
